import { FC, PropsWithChildren } from 'react';

import { Stack, Button } from '@eneco/sparky';
import { ButtonProps, StackProps } from '@eneco/sparky/types';

interface Props extends Partial<Pick<StackProps, 'alignY' | 'alignX'>> {
  isLoading?: boolean;
  /** Stretch the button across the full width of its container. */
  isFullWidth?: boolean;
  size?: ButtonProps['size'];
}

export const NextButton: FC<PropsWithChildren<Props>> = ({
  isLoading,
  alignY,
  alignX,
  isFullWidth,
  size,
  children,
}) => (
  <Stack
    direction={isFullWidth ? 'column' : { initial: 'column', md: 'row' }}
    alignY={alignY}
    alignX={isFullWidth ? undefined : alignX}>
    <Button type="submit" size={size} isLoading={isLoading}>
      {children}
    </Button>
  </Stack>
);
